import { ExtraBenefitMasterConstants } from "../constants/ExtraBenefitMasterConstants";

export function ExtraBenefitMaster(state = {}, action) {
  switch (action.type) {
    case ExtraBenefitMasterConstants.LOADING_REQUEST:
      return {
        ...state,
        loding: action.isbool,
      };
    case ExtraBenefitMasterConstants.DIALOG_REQUEST:
      return {
        ...state,
        showDialog: action.isbool,
      };
    case ExtraBenefitMasterConstants.DIALOG_REQUEST2:
      return {
        ...state,
        showDialog2: action.isbool,
      };
    case ExtraBenefitMasterConstants.DIALOG_ISACTIVE_REQUEST:
      return {
        ...state,
        showIsActiveDialog: action.isbool,
      };
    case ExtraBenefitMasterConstants.DIALOG_ISACTIVE_REQUEST2:
      return {
        ...state,
        showIsActiveDialog2: action.isbool,
      };
    case ExtraBenefitMasterConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ExtraBenefitMasterConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.datas,
      };

    case ExtraBenefitMasterConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case ExtraBenefitMasterConstants.GETSUBALL_REQUEST:
      return {
        ...state,
        loading2: true,
      };

    case ExtraBenefitMasterConstants.GETSUBALL_SUCCESS:
      return {
        ...state,
        subItems: action.datas,
      };

    case ExtraBenefitMasterConstants.GETSUBALL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case ExtraBenefitMasterConstants.GETALL_AVAILABLE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ExtraBenefitMasterConstants.GETALL_AVAILABLE_SUCCESS:
      return {
        ...state,
        Mappseries: action.datas,
      };
    case ExtraBenefitMasterConstants.GETALL_AVAILABLE_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case ExtraBenefitMasterConstants.CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      };
    case ExtraBenefitMasterConstants.CREATE_SUCCESS:
      return {
        ...state,
        items:
          state.items == null ? [action.data] : [action.data, ...state.items],
      };
    case ExtraBenefitMasterConstants.CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case ExtraBenefitMasterConstants.UPDATE_REQUEST:
      return {
        ...state,
        items: state.items.map((item) =>
          item.CategoryId === action.data.CategoryId
            ? { ...item, updating: true }
            : item
        ),
      };
    case ExtraBenefitMasterConstants.UPDATE_SUCCESS:
      return {
        ...state,
        items: state.items.map((item) =>
          item.CategoryId === action.data.CategoryId ? action.data : item
        ),
      };
    case ExtraBenefitMasterConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case ExtraBenefitMasterConstants.DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      };
    case ExtraBenefitMasterConstants.DELETE_SUCCESS:
      return {
        ...state,
        items: state.items.map((item) =>
          item.CategoryId === action.data
            ? {
                CategoryName: item.CategoryName,
                isActive: item.isActive,
              }
            : item
        ),
      };
    case ExtraBenefitMasterConstants.DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case ExtraBenefitMasterConstants.ISACTIVE_REQUEST:
      return {
        ...state,
        activating: true,
      };
    case ExtraBenefitMasterConstants.ISACTIVE_SUCCESS:
      return {
        ...state,
        items: state.items.map((item) =>
          item.CategoryId === action.data.CategoryId
            ? {
                CategoryName: item.CategoryName,
                FilePath: item.FilePath,
                TotalRows: item.TotalRows,
                IsActive: action.data.IsActive,
                CreatedDate: item.CreatedDate,
              }
            : item
        ),
      };
    case ExtraBenefitMasterConstants.ISACTIVE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case ExtraBenefitMasterConstants.ISACTIVE2_REQUEST:
      return {
        ...state,
        activating: true,
      };
    case ExtraBenefitMasterConstants.ISACTIVE2_SUCCESS:
      return {
        ...state,
        subItems: state.subItems.map((item) =>
          item.SubCatId === action.data.SubCatId
            ? {
                CategoryName: item.CategoryName,
                SubCategoryName: item.SubCategoryName,
                SubCateFilePath: item.SubCateFilePath,
                TotalRows: item.TotalRows,
                IsActive: action.data.IsActive,
                CreatedDate: item.CreatedDate,
              }
            : item
        ),
      };
    case ExtraBenefitMasterConstants.ISACTIVE2_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case ExtraBenefitMasterConstants.GETCATEGORYDDL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ExtraBenefitMasterConstants.GETCATEGORYDDL_SUCCESS:
      return {
        ...state,
        categoryddl: action.datas,
      };
    case ExtraBenefitMasterConstants.GETCATEGOYRDDL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    // DELETE_REQUEST:

    case ExtraBenefitMasterConstants.GETSUBCATEGORYDDL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ExtraBenefitMasterConstants.GETSUBCATEGORYDDL_SUCCESS:
      return {
        ...state,
        subcategoryddl: action.datas,
      };
    case ExtraBenefitMasterConstants.GETSUBCATEGOYRDDL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}
